import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M-2,-8h4v1h-4zM-2,-1h0.5v0.5h-0.5zM-2,-0.5h2v0.5h-2zM1,-0.5h1v0.5h-1zM-1.5,0h3v0.5h-3z',
    },
    {
      paint: 'lighthouse',
      d: 'M-1.5,-7h1.5v0.5h-1.5zM-1.5,-6.5h1v1h-1zM-1.5,-5.5h1.5v0.5h-1.5zM-1,-5h1v0.5h-1zM-1.5,-3h1.5v1.5h-1.5zM-1.5,-1.5h0.5v1h-0.5z',
    },
    {
      paint: 'heron',
      d: 'M0,-7h1v0.5h-1zM0,-6.5h1.5v2h-1.5zM-1.5,-5h0.5v0.5h-0.5zM0,-3h1.5v2h-1.5zM0,-1h2v0.5h-2zM0,-0.5h1v0.5h-1z',
    },
    {
      paint: 'buoy',
      d: 'M-0.5,-11h0.5v0.5h-0.5zM-1,-10.5h1.5v0.5h-1.5zM-1.5,-10h2.5v0.5h-2.5zM-1.5,-9.5h3v0.5h-3zM-1.5,-4.5h3v1.5h-3z',
    },
    { paint: 'trunk', d: 'M-1.5,-9h0.5v1h-0.5zM1,-9h0.5v1h-0.5zM-0.5,-1.5h0.5v1h-0.5z' },
    { paint: 'whale', d: 'M-0.5,-6.5h0.5v1h-0.5z' },
    { paint: 'lanternGlow', d: 'M-1,-9h2v1h-2zM-1,-1.5h0.5v1h-0.5z' },
  ],
  pixels: 136,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
